import { render } from "./HeadDash.vue?vue&type=template&id=a6d5301e&ts=true"
import script from "./HeadDash.vue?vue&type=script&lang=ts"
export * from "./HeadDash.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__